<app-base-notification [base]="base">
  <div [innerHTML]="'notifications.you_successfully_enrolled_in_meeting.text' | customLocale: {
    'meeting_title': title,
    'meeting_begin_at': meetingBeginAt | date : 'dd/MM/yyyy HH:mm',
    'teacher_fullname': teacher,
  }"></div>
</app-base-notification>
